
import { Component, Vue, Watch } from "vue-property-decorator";
import LayoutDefault from "@/components/layout/default/LayoutDefault.vue";
import { Money } from 'v-money';
import vSelect from "vue-select";
import "datatables.net-colreorder-dt";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.colVis";
import "datatables.net-fixedcolumns-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net";
import "datatables.net-buttons";
import "datatables.net-buttons-bs4";
import RankingService from "@/services/auth/RankingService";

@Component({
  components: {
    LayoutDefault,
    Money,
    vSelect
  }
})
export default class Ranking extends Vue {

  private date = new Date();

  private checkboxSelect: any = '';
  private loading = false;

  private usersGeneral: any = [];
  private usersVertical: any = [];
  private usersMyTeam: any = [];

  private myIndexGeneral:any = null;
  private myIndexVertical:any = null;
  private myIndexMyTeam:any = null;

  private generalLength: any = 0;
  private verticalLength: any = 0;
  private myTeamLength: any = 0;

  private auxUsersGeneral  = [];
  private auxUsersVertical = [];
  private auxUsersMyTeam   = [];

  private pathAvatarSuffix:string = process.env.NODE_ENV === 'development'
    ? 'development'
    : 'production';

  private monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
    "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
  ];

  private defaultSelected = [{
    label: `Ranking mensal (
      ${this.monthNames[this.date.getUTCMonth()]} / ${this.date.getUTCFullYear().toString()}
    )`,
    value: 'month'
  }];

  private researchPeriod = [{
    label: `Ranking anual (
      ${this.date.getUTCFullYear().toString()}
    )`,
    value: 'year'
  }, {
    label: `Ranking mensal (
      ${this.monthNames[this.date.getUTCMonth()]} / ${this.date.getUTCFullYear().toString()}
    )`,
    value: 'month'
  }, {
    label: `Ranking diário (
      ${this.date.toLocaleString().split('/')[0]} / ${(this.date.getUTCMonth() < 10) ? ('0' + this.date.getUTCMonth().toString()) : this.date.getUTCMonth()} / ${this.date.getUTCFullYear()}
    )`,
    value: 'day'
  }];

  private changedRanking(event) {
    if(event.value == 'year') {
      this.updateRanking(event.value);

    } else if(event.value == 'month') {
      this.updateRanking(event.value);

    } else if(event.value == 'day') {
      this.updateRanking(event.value);
    }
  }

  setLocalStorage(value:string){
    localStorage.setItem('ranking-painel-select', value)
  }

  private async mounted() {
    this.checkboxSelect = localStorage.getItem('ranking-painel-select');
    this.updateRanking('month');
  }

  private async updateRanking(perperiodicity: string) {
    const rankingServiceInstance = new RankingService();

    this.loading = true;

    this.auxUsersGeneral = [];
    this.auxUsersVertical =[];
    this.auxUsersMyTeam = [];

    this.usersGeneral = [];
    this.usersVertical = [];
    this.usersMyTeam = [];

    this.myIndexGeneral = null;
    this.myIndexVertical = null;
    this.myIndexMyTeam = null;

    try {
        this.auxUsersGeneral =  await rankingServiceInstance.show(perperiodicity);
        this.auxUsersVertical =  await rankingServiceInstance.show(perperiodicity, this.$auth.user().id_platform);
        this.auxUsersMyTeam =  await rankingServiceInstance.show(perperiodicity, this.$auth.user().id_platform, this.$auth.user().id_user);

        this.generalLength = this.auxUsersGeneral.length;
        this.verticalLength = this.auxUsersVertical.length;
        this.myTeamLength = this.auxUsersMyTeam.length;

        let pos = 1, userCheck = false;

        for (let index = 0; index < this.auxUsersGeneral.length; index++) {
            let obj: any = {};

            obj = this.auxUsersGeneral[index];
            obj.pos = pos;

            if(index > 0 && this.auxUsersGeneral[index]['conquest_amount'] != this.auxUsersGeneral[index - 1]['conquest_amount']) {
              pos++;
              obj.pos = pos;
            }

            if(index <= 9)
                this.usersGeneral.push(obj);

            if(this.auxUsersGeneral[index]['id_user'] == this.$auth.user().id_user)
              userCheck = true;

            if(index > 9 && this.auxUsersGeneral[index]['id_user'] == this.$auth.user().id_user){
                this.myIndexGeneral = pos;
                this.usersGeneral.push(obj);
                break;
            }

            if(!userCheck && this.auxUsersGeneral.length == (index + 1) && !this.myIndexGeneral) {
              this.myIndexGeneral = pos + 1;
              this.usersGeneral.push({
                conquest_amount: '-',
                conquest_total: '-',
                platform_name: this.$auth.user().platform,
                user_name: this.$auth.user().name,
                pos: pos + 1,
                id_user: this.$auth.user().id_user
              });
            }
        }

        pos = 1, userCheck = false;

        for (let index = 0; index < this.auxUsersVertical.length; index++) {
            let obj: any = {};

            obj = this.auxUsersVertical[index];
            obj.pos = pos;

            if(index > 0 && this.auxUsersVertical[index]['conquest_amount'] != this.auxUsersVertical[index - 1]['conquest_amount']) {
              pos++;
              obj.pos = pos;
            }

            if(index <= 9)
                this.usersVertical.push(obj);

            if(this.auxUsersVertical[index]['id_user'] == this.$auth.user().id_user)
              userCheck = true;

            if(index > 9 && this.auxUsersVertical[index]['id_user'] == this.$auth.user().id_user){
                this.myIndexVertical = pos;
                this.usersVertical.push(obj);
                break;
            }

            if(!userCheck && this.auxUsersVertical.length == (index + 1) && !this.myIndexVertical) {
              this.myIndexVertical = pos + 1;
              this.usersVertical.push({
                conquest_amount: '-',
                conquest_total: '-',
                platform_name: this.$auth.user().platform,
                user_name: this.$auth.user().name,
                pos: pos + 1,
                id_user: this.$auth.user().id_user
              });
            }
        }

        pos = 1, userCheck = false;

        for (let index = 0; index < this.auxUsersMyTeam.length; index++) {
            let obj: any = {};

            obj = this.auxUsersMyTeam[index];
            obj.pos = pos;

            if(index > 0 && this.auxUsersMyTeam[index]['conquest_amount'] != this.auxUsersMyTeam[index - 1]['conquest_amount']) {
              pos++;
              obj.pos = pos;
            }

            if(index <= 9)
                this.usersMyTeam.push(obj);

            if(this.auxUsersMyTeam[index]['id_user'] == this.$auth.user().id_user)
              userCheck = true;

            if(!userCheck && index > 9 && this.auxUsersMyTeam[index]['id_user'] == this.$auth.user().id_user){
                this.myIndexMyTeam = pos;
                this.usersMyTeam.push(obj);
                break;
            }

            if(!userCheck && this.auxUsersMyTeam.length == (index + 1) && !this.myIndexMyTeam) {
              this.myIndexMyTeam = pos + 1;
              this.usersMyTeam.push({
                conquest_amount: '-',
                conquest_total: '-',
                platform_name: this.$auth.user().platform,
                user_name: this.$auth.user().name,
                pos: pos + 1,
                id_user: this.$auth.user().id_user
              });
            }
        }
    } catch (error) {
        this.loading = false;
        console.log(error);
    }

    this.loading = false;
  }
}
